/**
 * Same as `Object.entries` but with better type inference.
 */
export function objectEntries<T extends object>(obj: T): [keyof T, T[keyof T]][] {
  return Object.entries(obj) as [keyof T, T[keyof T]][]
}

/**
 * Same as `Object.values` but with better type inference.
 */
export function objectValues<T extends object>(obj: T): T[keyof T][] {
  return Object.values(obj)
}

/**
 * Same as `Object.keys` but with better type inference.
 */
export function objectKeys<T extends object>(obj: T): (keyof T)[] {
  return Object.keys(obj) as (keyof T)[]
}
